var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1647762240484,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1685,
    fill: "#8a8a8a",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M823.854545 800.581818c83.781818-83.781818 134.981818-200.145455 134.981819-330.472727 0-260.654545-209.454545-470.109091-465.454546-470.109091S32.581818 209.454545 32.581818 470.109091s209.454545 470.109091 460.8 470.109091c102.4 0 195.490909-32.581818 274.618182-93.090909l172.218182 176.872727 51.2-51.2-167.563637-172.218182z m-330.472727 65.163637c-214.109091 0-390.981818-176.872727-390.981818-395.636364S279.272727 74.472727 493.381818 74.472727c214.109091 0 390.981818 176.872727 390.981818 395.636364s-176.872727 395.636364-390.981818 395.636364z",
    "p-id": 1686,
    fill: "#8a8a8a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M623.709091 577.163636v-279.272727c0-18.618182-13.963636-27.927273-27.927273-27.927273h-279.272727c-18.618182 0-27.927273 13.963636-27.927273 27.927273v274.618182c0 18.618182 13.963636 27.927273 27.927273 27.927273h279.272727c13.963636 4.654545 27.927273-9.309091 27.927273-23.272728z m-60.509091-32.581818H344.436364V330.472727h218.763636v214.109091z",
    "p-id": 1687,
    fill: "#8a8a8a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M651.636364 633.018182h-172.218182v60.509091h204.8c18.618182 0 27.927273-13.963636 27.927273-27.927273V456.145455H651.636364v176.872727z",
    "p-id": 1688,
    fill: "#8a8a8a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelated);
export default __webpack_public_path__ + "static/media/related.e80d39150800d9d3ac8bd73c7d6f0f52.svg";
export { ForwardRef as ReactComponent };